import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import Box from "@mui/material/Box";
import { alpha, useTheme } from "@mui/material/styles";

const Label = ({ className = "", color = "secondary", colorCode, children, style, ...rest }) => {
  const theme = useTheme();

  const baseStyles = {
    fontFamily: theme.typography.fontFamily,
    alignItems: "center",
    borderRadius: 2,
    display: "inline-flex",
    flexGrow: 0,
    whiteSpace: "nowrap",
    cursor: "default",
    flexShrink: 0,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightMedium,
    height: 20,
    justifyContent: "center",
    letterSpacing: 0.5,
    minWidth: 20,
    padding: theme.spacing(0.5, 1),
    textTransform: "uppercase",
  };

  const getColorStyles = () => {
    switch (color) {
      case "primary":
        return {
          color: theme.palette.primary.main,
          backgroundColor: alpha(theme.palette.primary.main, 0.08),
        };
      case "secondary":
        return {
          color: theme.palette.secondary.main,
          backgroundColor: alpha(theme.palette.secondary.main, 0.08),
        };
      case "info":
        return {
          color: theme.palette.info.main,
          backgroundColor: alpha(theme.palette.info.main, 0.08),
        };
      case "error":
        return {
          color: theme.palette.error.main,
          backgroundColor: alpha(theme.palette.error.main, 0.08),
        };
      case "success":
        return {
          color: theme.palette.success.main,
          backgroundColor: alpha(theme.palette.success.main, 0.08),
        };
      case "warning":
        return {
          color: theme.palette.warning.main,
          backgroundColor: alpha(theme.palette.warning.main, 0.08),
        };
      case "disabled":
        return {
          color: theme.palette.grey[800],
          backgroundColor: alpha(theme.palette.grey[800], 0.08),
        };
      case "contrast":
        return {
          color: theme.palette.common.black,
          backgroundColor: alpha(theme.palette.common.white, 0.85),
        };
      default:
        return {};
    }
  };

  const colorStyles = getColorStyles();

  return (
    <Box
      component="span"
      className={clsx(className)}
      sx={{
        ...baseStyles,
        ...colorStyles,
      }}
      style={colorCode ? { backgroundColor: colorCode, color: "#FFF" } : {}}
      {...rest}
    >
      {children}
    </Box>
  );
};

Label.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string,
};

export default Label;
